/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes, { object } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import {
  NavList,
  NavListItem,
  Icon,
  DropdownMenu,
  Dropdown,
  Button,
} from '@folio/stripes-components';
import useLocalization from '../../../helpers/useLocalization';

const propTypes = {
  dataOptions: PropTypes.arrayOf(object),
  currentDashboard: PropTypes.object,
  setCurrentDashboard: PropTypes.func,
};

const DashboardsMenu = ({
  dataOptions,
  currentDashboard,
  setCurrentDashboard,
  history,
  location,
}) => {
  const [DropdownOpen, setDropdownOpen] = useState(false);
  const { getLocalizedValue } = useLocalization();

  // Get dashboard ID from URL
  const pathParts = location?.pathname?.split('/');
  const dashboardIdFromUrl = pathParts[3];

  const toggleDropdown = () => {
    setDropdownOpen(!DropdownOpen);
  };

  const getDropdownContent = () => {
    return (
      <div>
        <NavList>
          {dataOptions?.map((dashboard) => {
            const isSelected = dashboardIdFromUrl === dashboard?.id;
            return (
              <NavListItem
                key={dashboard.id}
                id={`dashboards-menu-${dashboard?.id}`}
                isActive={isSelected}
                onClick={() => {
                  setCurrentDashboard(dashboard);
                  history.push(`/reports/dashboards/${dashboard.id}`);
                  toggleDropdown();
                }}
              >
                {getLocalizedValue(dashboard?.name)}
              </NavListItem>
            );
          })}
        </NavList>
      </div>
    );
  };

  const renderLocalesTrigger = ({ getTriggerProps, open }) => {
    return (
      <FormattedMessage
        id="ui-reports.dashboardsMenu"
        defaultMessage="Dashboards Menu"
      >
        {(label) => (
          <Button
            data-role="toggle"
            ariaLabel={label}
            buttonStyle="slim"
            selected={open}
            marginBottom0
            {...getTriggerProps()}
          >
            <Icon iconPosition="end" icon={open ? 'caret-up' : 'caret-down'}>
              {getLocalizedValue(currentDashboard?.name)}
            </Icon>
          </Button>
        )}
      </FormattedMessage>
    );
  };

  const renderLocalesMenu = ({ open }) => (
    <DropdownMenu open={open}>{getDropdownContent()}</DropdownMenu>
  );

  return (
    <>
      <Dropdown
        id="dashboards-list-dropdown"
        renderTrigger={renderLocalesTrigger}
        renderMenu={renderLocalesMenu}
        open={DropdownOpen}
        onToggle={toggleDropdown}
        placement="bottom"
        // usePortal={false}
        relativePosition
        focusHandlers={{ open: () => null }}
      />
    </>
  );
};

DashboardsMenu.propTypes = propTypes;

export default withRouter(DashboardsMenu);
